import { useEffect, useState } from 'react';
import { fullstoryEvent, FSProperties } from '@/fullstory/utils/fullstory-event';
import { Session } from '@/common/types/session';
import { fullstoryCheckoutPropsFromSession } from '../utils/fullstory-checkout-props-from-session';

// Please only pass session if checkout params are an explicit requirement for your event.
// It generally should be excluded.
export const useFullstoryPageLoadEvent = (
  eventName?: string,
  properties?: FSProperties,
  session?: Session
) => {
  const [hasSent, setHasSent] = useState(false);

  useEffect(() => {
    if (!hasSent && eventName) {
      setHasSent(true);

      const checkoutProperties = session
        ? fullstoryCheckoutPropsFromSession(session)
        : {};

      fullstoryEvent(eventName, { ...properties, ...checkoutProperties });
    }
  }, [hasSent, setHasSent, eventName, properties, session]);
};
